import React from 'react';
import { PenTool, LayoutGrid, Zap } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

interface HeaderProps {
    currentView: 'create' | 'history';
    onNavigate: (view: 'create' | 'history') => void;
    onOpenPricing: () => void;
}

const Header: React.FC<HeaderProps> = ({ currentView, onNavigate, onOpenPricing }) => {
  const { user, credits } = useAuth();

  return (
    <header className="w-full py-6 px-4 flex items-center justify-between max-w-4xl mx-auto z-10">
      {/* Logo */}
      <a 
        onClick={(e) => { e.preventDefault(); onNavigate('create'); }} 
        href="/" 
        className="flex items-center gap-3 transform -rotate-2 hover:rotate-0 transition-transform duration-300 cursor-pointer group"
      >
        <div className="bg-black text-white p-2 rounded-md shadow-[3px_3px_0px_0px_rgba(0,0,0,0.2)] group-hover:shadow-[3px_3px_0px_0px_rgba(0,0,0,1)] transition-shadow">
          <PenTool size={20} strokeWidth={2} />
        </div>
        <h1 className="text-2xl md:text-3xl font-bold text-gray-900 font-hand">
          <span className="highlight px-2">LogiSketch</span>
        </h1>
      </a>

      {/* Navigation */}
      <div className="flex items-center gap-3">
        {user && credits !== null && (
            <button 
                onClick={onOpenPricing}
                className={`flex items-center gap-1 px-3 py-2 rounded-md font-hand font-bold border-2 transition-all ${credits > 0 ? 'bg-yellow-100 border-black text-black hover:bg-yellow-200' : 'bg-red-100 border-red-500 text-red-600 animate-pulse'}`}
                title="Buy Credits"
            >
                <Zap size={16} className={credits > 0 ? "fill-black" : "fill-red-600"} />
                <span>{credits} Credits</span>
            </button>
        )}

        <button 
            onClick={() => onNavigate(currentView === 'create' ? 'history' : 'create')}
            className={`
                flex items-center gap-2 px-4 py-2 rounded-md font-hand font-bold border-2 border-black transition-all
                ${currentView === 'history' 
                    ? 'bg-black text-white shadow-[4px_4px_0px_0px_rgba(200,200,200,1)]' 
                    : 'bg-white hover:bg-gray-50 hover:shadow-[4px_4px_0px_0px_rgba(0,0,0,1)] hover:-translate-y-1'}
            `}
        >
            {currentView === 'create' ? (
                <>
                    <LayoutGrid size={18} />
                    <span className="hidden sm:inline">My Sketches</span>
                </>
            ) : (
                <>
                    <PenTool size={18} />
                    <span className="hidden sm:inline">Create New</span>
                </>
            )}
        </button>
      </div>
    </header>
  );
};

export default Header;